export default __webpack_public_path__ + "static/media/flag-solomon-islands.869c76be.svg";